<template>
  <v-btn
    flat
    light
    icon
    color="cyan"
    v-if="article.status === 'googleOk'"
    @click.native="translate"
    :loading="loading"
  >
    <v-icon>language</v-icon>
  <template v-slot:loader>
    <span class="custom-loader">
      <v-icon light color="cyan">cached</v-icon>
    </span>
  </template>
  </v-btn>
</template>

<script>
  import { mapActions } from 'vuex';
  export default {
    name: 'TranslateBtn',
    props: ['article', 'projectId'],
    data() {
      return {
        loading: false,
      };
    },
    methods: {
      ...mapActions(['snackbar']),
      async translate() {
        this.loading = true;
        try {
          await this.$http.get(`/api/articles/translate/${this.article.id}`);
          this.$router.push({ name: 'Article', params: { articleId: this.article.id } });
        } catch (e) {
          this.snackbar({ color: 'error', text: 'Impossible de traduire l\'article' });
        }
        this.loading = false;
      }
    }
  }
</script>

<style scoped lang="scss">
  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
  }
  @-moz-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-webkit-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-o-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
</style>
